var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingCashbackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#EEEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.204 21.1342C12.9572 21.0749 12.9869 19.6797 12.9869 19.6797C12.9572 21.2084 11.7104 21.1342 11.7104 21.1342C11.7104 21.1342 12.9869 21.253 12.9869 22.5443C12.9869 22.5443 13.1353 21.253 14.204 21.1342Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6809 18.7874C10.8943 18.7429 10.9091 17.8672 10.9091 17.8672C10.8943 18.8319 10.0928 18.7874 10.0928 18.7874C10.0928 18.7874 10.9091 18.8616 10.9091 19.6779C10.9091 19.6779 11.013 18.8616 11.6809 18.7874Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1762 21.6255C8.38581 21.477 8.46002 18.375 8.46002 18.375C8.38581 21.7739 5.59546 21.6255 5.59546 21.6255C5.59546 21.6255 8.46002 21.9075 8.46002 24.7869C8.46002 24.7869 8.83108 21.8926 11.1762 21.6255Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1992 18C27.7268 19.4602 27.4619 21.0206 27.4619 22.6383C27.4619 30.9415 34.1903 37.6699 42.4935 37.6699C44.691 37.6699 46.7739 37.1903 48.6564 36.3385V18H28.1992Z",
    fill: "#D3D5E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7596_48891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3798 23.8769V32.5523H26.0518C25.2644 32.5523 24.6202 33.1893 24.6202 33.9838V37.8777H16.9684C16.1811 37.8777 15.5369 37.2407 15.5369 36.4462V23.8769C15.5369 23.0824 16.1811 22.4453 16.9684 22.4453H37.9554C38.7428 22.4453 39.3798 23.0824 39.3798 23.8769Z",
    fill: "#E9F4BC"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3798 25.0625H15.5369V28.0974H39.3798V25.0625Z",
    fill: "#79CAA1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7596_48891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4631 33.9785V46.5406C48.4631 47.3279 47.826 47.9721 47.0315 47.9721H26.0517C25.2643 47.9721 24.6201 47.3351 24.6201 46.5406V33.9785C24.6201 33.1911 25.2643 32.5469 26.0517 32.5469H47.0315C47.826 32.5469 48.4631 33.1839 48.4631 33.9785Z",
    fill: "#FF9D9C"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3864 35.2031H27.2756V40.3139H32.3864V35.2031Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4521 22.9806C19.7528 22.9806 19.989 22.7444 19.989 22.4437C19.989 22.1503 19.7528 21.9141 19.4521 21.9141C19.1587 21.9141 18.9153 22.1503 18.9153 22.4437C18.9153 22.7444 19.1587 22.9806 19.4521 22.9806Z",
    fill: "#1E247E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0316 32.0067H39.9166V23.8753C39.9166 22.7945 39.0362 21.9141 37.9554 21.9141H20.8838C20.5903 21.9141 20.3469 22.1503 20.3469 22.4437C20.3469 22.7444 20.5903 22.9806 20.8838 22.9806H37.9554C38.4493 22.9806 38.8429 23.3743 38.8429 23.8753V24.5267H16.0737V23.8753C16.0737 23.3814 16.4745 22.9806 16.9684 22.9806H18.0206C18.3213 22.9806 18.5575 22.7444 18.5575 22.4437C18.5575 22.1503 18.3213 21.9141 18.0206 21.9141H16.9684C15.8804 21.9141 15 22.7945 15 23.8753V36.4374C15 37.5254 15.8804 38.4059 16.9684 38.4059H24.0834V46.5372C24.0834 47.6181 24.9638 48.5056 26.0518 48.5056H47.0316C48.1124 48.5056 49 47.6252 49 46.5372V33.9751C49 32.8871 48.1196 32.0067 47.0316 32.0067ZM16.0737 25.6004H38.8429V27.5616H16.0737V25.6004ZM16.9684 37.3322C16.4745 37.3322 16.0737 36.9313 16.0737 36.4374V28.6353H38.8429V32.0067H26.0518C24.9709 32.0067 24.0834 32.8871 24.0834 33.9751V37.3322H16.9684ZM47.9263 46.5372C47.9263 47.0311 47.5255 47.432 47.0316 47.432H26.0518C25.5579 47.432 25.1571 47.0311 25.1571 46.5372V33.9751C25.1571 33.4812 25.5579 33.0804 26.0518 33.0804H47.0316C47.5255 33.0804 47.9263 33.4812 47.9263 33.9751V46.5372Z",
    fill: "#1E247E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2756 40.8485H32.3863C32.6798 40.8485 32.9232 40.6051 32.9232 40.3116V35.2009C32.9232 34.9074 32.6798 34.6641 32.3863 34.6641H27.2756C26.9821 34.6641 26.7388 34.9074 26.7388 35.2009V40.3116C26.7388 40.6051 26.9821 40.8485 27.2756 40.8485ZM27.8125 35.7377H31.8495V39.7748H27.8125V35.7377Z",
    fill: "#1E247E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8599 44.6719H26.6889C26.3955 44.6719 26.1521 44.9152 26.1521 45.2087C26.1521 45.5022 26.3955 45.7456 26.6889 45.7456H29.8599C30.1534 45.7456 30.3967 45.5022 30.3967 45.2087C30.3967 44.9152 30.1605 44.6719 29.8599 44.6719Z",
    fill: "#1E247E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3714 44.6719H32.2004C31.9069 44.6719 31.6636 44.9152 31.6636 45.2087C31.6636 45.5022 31.9069 45.7456 32.2004 45.7456H35.3714C35.6648 45.7456 35.9082 45.5022 35.9082 45.2087C35.9082 44.9152 35.6648 44.6719 35.3714 44.6719Z",
    fill: "#1E247E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8828 44.6719H37.7119C37.4184 44.6719 37.175 44.9152 37.175 45.2087C37.175 45.5022 37.4184 45.7456 37.7119 45.7456H40.8828C41.1763 45.7456 41.4197 45.5022 41.4197 45.2087C41.4197 44.9152 41.1763 44.6719 40.8828 44.6719Z",
    fill: "#1E247E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3946 44.6719H43.2236C42.9301 44.6719 42.6868 44.9152 42.6868 45.2087C42.6868 45.5022 42.9301 45.7456 43.2236 45.7456H46.3946C46.688 45.7456 46.9314 45.5022 46.9314 45.2087C46.9314 44.9152 46.688 44.6719 46.3946 44.6719Z",
    fill: "#1E247E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6401 6.91785L39.2041 5.65625",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8293 5.53906L37.0817 6.97877",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7366 6.32812L35.5826 7.30772",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7596_48891",
    x: 15.5369,
    y: 22.4453,
    width: 23.843,
    height: 17.4297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308802 0 0 0 0 0.504167 0 0 0 0 0.410392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7596_48891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7596_48891",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7596_48891",
    x: 24.6201,
    y: 32.5469,
    width: 25.843,
    height: 17.4219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.38125 0 0 0 0 0.396 0 0 0 0 0.75 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7596_48891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7596_48891",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingCashbackIcon);
export default __webpack_public_path__ + "static/media/OnboardingCashbackIcon.b71842ee454917f0734c7e83ff8e35f3.svg";
export { ForwardRef as ReactComponent };